export function applyErrorMsg(el, msg = null) {
  let errorField = findOrCreateErrorContainer(el);
  let span = errorField.querySelector('span');
  span.innerText = msg || el.validationMessage;
};

const findOrCreateErrorContainer = (el) => {
  let parent = el.parentElement;
  let errorField = parent.querySelector('.error');
  if (!errorField) {
    errorField = document.createElement('div');
    errorField.className = 'error filled';
    errorField.appendChild(document.createElement('span'));
    parent.appendChild(errorField);
  }
  return errorField;
};

const removeErrorMsg = (el) => {
  let errorField = el.parentElement.querySelector('.error');
  if (errorField && errorField.classList.contains('error')) {
    errorField.remove();
  }
};

const customValidity = (el) => {
  if (el.validity.valueMissing) {
    let requiredMsg = el.dataset.parsleyRequiredMessage || 'Error: This field is required';
    el.setCustomValidity(requiredMsg);
  }

  if (el.type === 'email' && el.validity.typeMismatch) {
    el.setCustomValidity('This value should be a valid email.');
  }
};

const validateElement = (el) => {
  let eventType = 'valid';
  el.setCustomValidity('');
  if (el.checkValidity()) {
    el.classList.remove('parsley-error');
    removeErrorMsg(el);
  } else {
    eventType = 'invalid';
    el.classList.add('parsley-error');
    applyErrorMsg(el);
  }
  let event = new CustomEvent(`element-${eventType}`, {
    bubbles: true,
    detail: el.validationMessage,
  });
  el.dispatchEvent(event);
};

export function validateForm(form) {
  let skip = [
    'utf8',
    'authenticity_token',
    'button',
  ];

  Array.from(form.elements).forEach((el) => {
    if (!el.name || skip.includes(el.name)) return;
    el.addEventListener('input', () => validateElement(el));
    el.addEventListener('invalid', () => customValidity(el));
    validateElement(el);
  });

  return form.checkValidity();
};

export async function handleSubmitForm(form){
  let formData = new FormData(form);
  let valid = validateForm(form);

  if (!valid) return;

  let btn = form.querySelector('[data-disable-with]');
  let originalText = null;
  if (btn) {
    originalText = btn.innerText;
    btn.setAttribute('disabled', true);
    btn.innerText = btn.dataset.disableWith;
  }

  let response = await fetch(form.action, {
    method: form.method,
    body: formData,
  });

  if (btn) {
    btn.removeAttribute('disabled');
    btn.innerText = originalText;
  }
  return response.json();
};
